import type { ProjectItem } from '@customink/project-service-react-components';
import { useUpdateProjectItems } from '@customink/project-service-react-components';
import { SYNC_STRATEGIES } from '@customink/project-service-types';
import { useCallback } from 'react';

export const useUpdateItems = () => {
  const [trigger, result] = useUpdateProjectItems();
  const curriedTrigger = useCallback(
    (updateProjectItems: ProjectItem[]) =>
      trigger(updateProjectItems, SYNC_STRATEGIES.CORE_ORDER),
    [trigger],
  );
  return [curriedTrigger, result] as const;
};
